import { render, staticRenderFns } from "./invoices.vue?vue&type=template&id=697115a5&"
import script from "./invoices.vue?vue&type=script&lang=ts&"
export * from "./invoices.vue?vue&type=script&lang=ts&"
import style0 from "./invoices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports